import { mapValues } from '@exodus/basic-utils';
const ATOM_ID_REGEX = /Atom$/u;
const ATOM_COLLECTION_ID_REGEX = /Atoms$/u;
export const isAtom = (id) => ATOM_ID_REGEX.test(id);
export const isAtomCollection = (id) => ATOM_COLLECTION_ID_REGEX.test(id);
export const wrapAtomsWith = (node, fn) => {
    const { definition, ...rest } = node;
    const wrapAtom = ({ id, atom }) => {
        if (!atom)
            return atom;
        return fn(id, atom);
    };
    const wrapAtomCollection = ({ id, atomCollection, }) => {
        return mapValues(atomCollection, (atom) => wrapAtom({ id, atom }));
    };
    const factory = (dependencies) => {
        return definition.factory(mapValues(dependencies, (dependency, id) => {
            if (isAtom(id))
                return wrapAtom({ id, atom: dependency });
            if (isAtomCollection(id)) {
                return wrapAtomCollection({
                    id,
                    atomCollection: dependency,
                });
            }
            return dependency;
        }));
    };
    return { ...rest, definition: { ...definition, factory } };
};
